import React from "react";
import { Button, Link } from "@hdir/ui";

import { faArrowDownToLine } from "@fortawesome/pro-light-svg-icons";
import FontAwesomeIconWrapper from "../../../react4xp/shared/FontAwesomeIconWrapper/FontAwesomeIconWrapper";

import type { fileDownloadPropsType, ProcessedLink } from "./type.d";

const downloadProcessedLink = async(file: ProcessedLink | undefined) => {
  if (!file) {
    console.error("Cannot download file, Url is null");
    return;
  }

  if (file.openInNewTab) {
    window.open(file.linkUrl ?? "", "_blank");
  } else {
    const link = document.createElement("a");
    link.href = file.linkUrl ?? "";
    link.setAttribute("download", "");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const downloadMultipleFiles = async(event: React.MouseEvent<HTMLButtonElement>, files: ProcessedLink[] | null) => {
  if (!files) return;
  // eslint-disable-next-line no-restricted-syntax
  for (const file of files) {
    setTimeout(() => {
      event.preventDefault();
      downloadProcessedLink(file);
    }, 100);
  }
};

function FileDownloadItem({ file }: { file: ProcessedLink }) {
  return (file?.linkUrl)
      && (
        <Link
          variant="card"
          download={file.isLinkPdf ? undefined : true}
          href={file.linkUrl}
          target={file.openInNewTab ? "_blank" : undefined}
          className="!w-full shadow-none justify-center !pr-md"
        >
          <div className="flex gap-sm w-full justify-between">
            <p className="break-normal">{file.linkText}</p>
            <FontAwesomeIconWrapper
              className="self-center"
              icon={faArrowDownToLine}
              size="lg"
              style={{ color: "var(--design-color-icon-action-default)" }}
            />
          </div>
        </Link>
      );
}

function FileDownload(props: Readonly<fileDownloadPropsType>) {
  const {
    editMode, title, ingress, files, allFilesDownloadButtonText
  } = props;
  return (
    <>
      {(editMode && (files?.length === 0))
        ? <div className="bg-surface-feedback-error p-md">Part "Filnedlasting" mangler innhold. Legg til en fil for å vise noe her.</div>
        : (
          <div className="w-full py-design-component-mobile tablet:py-design-component-tablet desktop:py-design-component-desktop break-normal hyphens-auto">
            {title && <h2 className="lenkeboks-header mb-md text-xxl font-bold tw-title-and-preface-max-w">{title}</h2>}
            {ingress && <div className="my-md text-md tw-title-and-preface-max-w">{ingress}</div>}

            {files
              && (
                <div className="grid grid-cols-1 tablet:grid-cols-2 gap-sm">
                  {files.map((fileItem: ProcessedLink) => <FileDownloadItem file={fileItem} />)}
                </div>
              )}
            {allFilesDownloadButtonText
              && (
                <Button
                  className="py-md mt-lg"
                  size="medium"
                  variant="secondary"
                  onClick={(event) => downloadMultipleFiles(event, files)}
                >
                  {allFilesDownloadButtonText}
                </Button>
              )}
          </div>
        )}
    </>
  );
}

export default function(props: Readonly<fileDownloadPropsType>) {
  return <FileDownload {...props} />;
}
